import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { LooksOneRounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { OneWaySlabInput } from '@core/const'

export interface OneWaySlabHistory extends OneWaySlabInput {
  type: 'OneWaySlab',
  result: number
}

interface Props {
  history: OneWaySlabHistory
}
function OneWaySlabHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <LooksOneRounded />
        <Box className="grid grid-cols-2 gap-8 min-w-[16rem] overflow-auto">
          <HistoryItemField
            label={t('GLOSSARY.SLAB_TYPE')}
            value={t(`GLOSSARY.${history.slabType}`)}
          />
          <HistoryItemField
            label={t('GLOSSARY.SHORTSIDE_SPAN')}
            unit="m"
            value={history.beamSpan}
          />
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <HistoryItemField
          label={t('GLOSSARY.MIN_REQUIRED_THICKNESS')}
          unit="mm"
          value={history.result}
        />
      </CardContent>
    </Card>
  )
}

export default OneWaySlabHistoryItem
